import {axiosInstance} from "../helpers/axios";

const sendCall = (data) => {
    return axiosInstance.post('sendCall/', data ).then((res) => {
        const data = res.data;
        return data;
    }).
    catch(err => {
        console.log("error");
        console.log(err.message);
    });
}

export default { sendCall };